<template>
    <div class='ce'>
      <div>
        <span class="ce__title">Column Editor</span>
      </div>
      <div class="ce__row">
        <div>
          <div>
            <input type="checkbox"
                v-model="allSelected"
                @change="selectAll(!allSelected)"
                id="select-all-checkbox"
                />
                <label class="ce__checkbox-label" for="select-all-checkbox">Select All</label>
          </div>
        </div>
      </div>
      <div class="ce__row">
        <div class="ce__column">
          <div v-for="(column, i) in computedColumns" :key="i">
              <label>
                <input type="checkbox"
                v-model="column._column.visible"
                :id="column._column.field + '_column_checkbox'"
                :data-field="column._column.field"
                @change="toggle(column._column.field)"
                />
                {{ column._column.definition.title }}
              </label>
          </div>
        </div>
      </div>
      <div class="ce__row">
        <div class="ce__controls">
          <button class="ce__button ce__button_cancel"
                  @click="close()">
            Close
          </button>
        </div>
      </div>
    </div>
</template>

<script>
import BaseModalMixins from '@/common/BaseModalMixins'

export default {
  name: 'ColumnEditor',
  mixins: [BaseModalMixins],
  props: {
    columns: Array
  },
  data () {
    return {
      allSelected: this.columns.filter(col => col._column.field !== 'edit_button')
        .every(column => column._column.visible)
    }
  },
  computed: {
    computedColumns () {
      return this.columns.filter(col => col._column.field !== 'edit_button')
    },
    noneSelected () {
      return this.computedColumns.every(column => !column._column.visible)
    }
  },
  watch: {
    noneSelected (val) {
      this.$emit('toggle', 'edit_button')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    toggle (field) {
      this.$emit('toggle', field)
      this.allSelected = this.computedColumns.every(column => column._column.visible)
    },
    selectAll (bool) {
      if (!bool) {
        this.computedColumns.forEach(column => {
          if (!column._column.visible) {
            this.$emit('toggle', column._column.field)
          }
        })
      } else {
        this.computedColumns.forEach(column => {
          if (column._column.visible) {
            this.$emit('toggle', column._column.field)
          }
        })
      }
    }
  }
}

</script>

<style scoped lang="scss">
label {
  cursor: pointer;
}

.ce {
    align-items: stretch;
    padding: 40px;

    &__title {
      display: block;
      text-align: center;
      font-size: 32px;
      font-weight: 500;
      margin-bottom: 30px;
    }

    &__row {
      display: flex;
    }

    &__column {
      flex: 50%;
      margin-top: 15px;
    }

    &__controls {
      margin-left: auto;
      order: 2;
      margin-top: 30px;
    }

    &__button {
      width: 100px;
      height: 40px;
      border-radius: 4px;
      font-size: 10px;
      font-weight: 900;
      text-transform: uppercase;
      margin-left: 30px;
      border: none;
      outline: none;
      cursor: pointer;

      &_cancel {
        background-color: $rfx-medium-march;
        color: #fff;
      }
    }

}
</style>
